import axios from "axios";


export default{
    getAllCurrency()
    {
        try {
            return axios.get("https://app-psod.cratis.cloud/api/financial/currency");
          } catch (err) {
            console.log(err);
          }
    },
    getSifarnik()
    {
        try {
            return axios.get("https://app-psod.cratis.cloud/api/financial/sifarnik");
          } catch (err) {
            console.log(err);
          }
    },
    getCaseTroskovnici(case_id)
    {
        try {
            return axios.get("https://app-psod.cratis.cloud/api/financial/troskovnici/"+case_id);
          } catch (err) {
            console.log(err);
          }
    }
}